import React from 'react';
import { Switch ,Route} from 'react-router-dom';
import Login from './Login';
import ReLogin from './ReLogin';
import Home from './home';
import PreHome from './preHome';
import Export from './export';
import AuthenticatedRoute from './AuthenticatedRoute';
import UnauthenticatedRoute from './UnauthenticatedRoute';
//import { QueryParamProvider } from 'use-query-params';

export default function Routes() {
  return (
//<QueryParamProvider ReactRouterRoute={Route}>
    
 <Switch>
      <AuthenticatedRoute exact path='/'>
        <Home />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path='/home'>
        <Home />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path='/home?microphone=true'>
        <Home />
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path='/search'>
        <PreHome />
      </AuthenticatedRoute>
      <AuthenticatedRoute path='/export/:sid'>
        <Export />
      </AuthenticatedRoute>
      <UnauthenticatedRoute exact path='/'>
        <ReLogin />
      </UnauthenticatedRoute>
    </Switch>
//</QueryParamProvider>
  );
}
